<template>
    <div class="entity-form" @click="(e)=>{e.stopPropagation()}">
        <form @submit.prevent="(e)=>{e.stopPropagation()}">
            <div class="form-heading">
                <div class="form-title">{{$t('form.partylist.heading')}}</div>
                <button class="button-primary  button-primary__thin" @click="cancelForm" >{{$t('form.partylist.cancel')}}</button>
            </div>

            <div class="flex-column" style="margin-top: 16px; padding: 24px;padding-right: 8px;">
                <div><PartyCalendar with-spacer="false"  time-span="open" @party-clicked="partyClicked" /></div>
            </div>
         </form>
    </div>
</template>

<script>


    import PartyCalendar from "../core/PartyCalendar";

    export default {
        name: "PartyListForm",
        components: {PartyCalendar},
        data() {
          return {

          }
        },

        props: {
            reference: {
                type: [ Number],
                default:-1
            }
        },
        computed:{

        },

        mounted(){

        },
        methods: {
            cancelForm(){
                this.$emit('form-closed')
               // this.$router.go({name: 'Party', params: {id: this.reference}})
            },
            partyClicked(id){
                this.$store.dispatch('moveParticipant',{
                    partyId:id,
                    custListId:this.reference
                }).then(()=>{


                    this.$nextTick(() => this.$router.push({name:'PartyCustomer', params:{id:id, custListId:this.reference}}))
                    this.$emit('form-closed')

                })
            }
        }
    }
</script>

<style scoped>

</style>
